export const useWizardItemRouteBuilder = (
    data: WizardData
): VNuxtLinkTo | null => {
    // prepare variable for result
    let result: VNuxtLinkTo | null = null

    // route names keyed by object keys which can includes route parameter
    const routeNamesByKey: Record<string, string> = {
        faq_category: 'faq-category',
        form: 'online-services-detail',
        product: 'insurance-detail',
    }

    // get values for route
    for (const key in routeNamesByKey) {
        const keyData = data[key as keyof WizardData]
        if (!keyData) continue

        // prepare query and id param
        let query = {}
        let id = null

        // build URL
        if (typeof keyData === 'string') {
            // get resource id(slug) and query parameters
            const [ID, search] = (keyData as string).split('?')

            // make object for query params
            query = search
                ? Object.fromEntries(new URLSearchParams(`${search}`))
                : {}
            // set id
            id = ID || null
        }

        if (!id) {
            id =
                key === 'product'
                    ? (keyData as WizardProduct).slug
                    : (keyData as string)
        }

        // build route object
        result = {
            name: routeNamesByKey[key],
            params: {
                category:
                    key === 'product'
                        ? (keyData as WizardProduct).category.slug
                        : 'all',
                id,
            },
            query,
        }
        break
    }
    return result
}
